import React from 'react';
import { BtnVerde } from './ButtomPrimary.style';
type TButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
  typeSubmit: boolean;
};
const ButtonPrimary: React.FC<TButtonProps> = ({ onClick, disabled = false, label, typeSubmit }) => {
  return (
    <>
      {typeSubmit ? (
        <BtnVerde type="submit" disabled={disabled} onClick={onClick}>
          {label}
        </BtnVerde>
      ) : (
        <BtnVerde disabled={disabled} onClick={onClick}>
          {label}
        </BtnVerde>
      )}
    </>
  );
};

export default ButtonPrimary;
